export enum USER_DIRECTORY {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=772233388
     */
    EDIT_MAIN_USER_DIRECTORY = 'USER_DIRECTORY.EDIT_MAIN_USER_DIRECTORY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=772233834
     */
    MAIN_DIRECTORY_MESSAGE = 'USER_DIRECTORY.MAIN_DIRECTORY_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=772233949
     */
    NO_MAIN_DIRECTORY_MESSAGE = 'USER_DIRECTORY.NO_MAIN_DIRECTORY_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=777983910
     */
    NOT_DEFAULT_SITE_TOOLTIP = 'USER_DIRECTORY.NOT_DEFAULT_SITE_TOOLTIP',
}
